export const THEME_PRIMARY_COLOR = '#624AF4';
